import type { FC } from 'react';
import { useEffect } from 'react';
import { Box, Card, CardContent, Container, Typography } from '@mui/material';
import { LoginJWT } from '../../components/authentication/login';
import { useTheme } from '@mui/material/styles';

const Login: FC<React.PropsWithChildren<unknown>> = () => {
  const theme = useTheme();

  useEffect(() => {
    document.title = 'Login | SFA Web';
  }, []);

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Container maxWidth="sm" sx={{ py: '80px' }}>
          <Card>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 4,
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 3,
                }}
              >
                <div>
                  <Typography color="textPrimary" gutterBottom variant="h4">
                    Log in
                  </Typography>
                  <Typography color="textSecondary" variant="body2">
                    Please enter your BFG Username and password.
                  </Typography>
                </div>
                <Box
                  sx={{
                    height: 32,
                    '& > img': {
                      // maxHeight: '100%',
                      maxWidth: '110px',
                      width: '100%',
                    },
                  }}
                >
                  {theme.palette.mode === 'light' ? (
                    <img alt="logo" src="/static/sfa_logo.svg" className="login-logo" />
                  ) : (
                    <img alt="logo" src="/static/sfa_logo_white.svg" className="login-logo" />
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  flexGrow: 1,
                  mt: 3,
                  mb: 2,
                }}
              >
                <LoginJWT />
              </Box>
              {/* <Divider sx={{ my: 3 }} /> */}
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default Login;
